import React from "react";
import Chip from "../Chip";
import MUIGreyColor from "@mui/material/colors/grey";
import MUIAvatar from "@mui/material/Avatar";
import Location from "../../Utility/Crud/Location";

export default class ChipLocation extends Chip {
    /**
     * Renders a MUI Avatar.
     */
    renderAvatar() {
        const color = (this.props.location || this.props.hasSelection ? Location.getColor() : MUIGreyColor[500]);
        const avatarColor = this.props.isTransparent ? "transparent" : color;
        const iconColor = this.props.isTransparent ? color : "#fff";

        return (
            <MUIAvatar sx={{ bgcolor: avatarColor }}>
                {Location.getIcon({ fontSize: "small", sx: { color: iconColor } })}
            </MUIAvatar>
        );
    }

    /**
     * @return {string} The location name.
     */
    getLabel() {
        if (this.props.location) {
            return this.props.labelPrefix
                ? `${this.props.labelPrefix}: ${Location.getDisplayName(this.props.location)}`
                : Location.getDisplayName(this.props.location);
        } else {
            return this.props.nullLabel || "None";
        }
    }
}
